export { ProductWizard } from '@fhs-legacy/frontend/src/pages/product-wizard';
